import {
  FileData,
  UseLoadFile,
} from '@wandb/weave/common/components/FileBrowser';
import WandbLoader from '@wandb/weave/common/components/WandbLoader';
import Prism from 'prismjs';
import React, {useCallback, useEffect, useRef, useState} from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Segment} from 'semantic-ui-react';

type LogPreviewProps = {
  useLoadFile: UseLoadFile;
  file: FileData;

  language?: string;
};

export const LogPreview = ({useLoadFile, file, language}: LogPreviewProps) => {
  const [data, setDataVal] = useState('');
  const [error, setErrorVal] = useState<string | undefined>(undefined);
  const ref = useRef<HTMLDivElement>(null);
  const setData = useCallback(
    (d: string) => {
      setDataVal(d);
    },
    [setDataVal]
  );
  const setError = useCallback(
    (errorString?: string) => setErrorVal(errorString || 'Error loading file'),
    [setErrorVal]
  );

  // We don't pass a fallback to allow dev mode zero byte files to render
  const loading = useLoadFile(file, {
    onSuccess: setData,
    onFailure: setError,
  });
  useEffect(() => {
    if (ref.current != null) {
      Prism.highlightElement(ref.current);
    }
  });
  if (error != null) {
    return <Segment textAlign="center">{error}</Segment>;
  }
  return (
    <>
      {loading ? (
        <WandbLoader name="log-preview-loader" />
      ) : (
        <div
          style={{
            background: 'white',
            border: '1px solid #eee',
            padding: 8,
          }}>
          <pre
            style={{
              maxWidth: '100%',
            }}>
            <code
              style={{
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-all',
                fontFamily: '"Andale Mono", monospace',
                lineHeight: '150%',
                fontSize: '14px',
              }}
              ref={ref}
              className={language != null ? `language-${language}` : undefined}>
              {data}
            </code>
          </pre>
        </div>
      )}
    </>
  );
};
